/* ==========================================================================
   GC CART UPSELL — shared add-to-cart brain — v2 — 18 Aug 2026
   Loaded globally (via the cart drawer) and on the cart page.
   Any <gc-cart-upsell> element delegates its .gc-add-form submits here.

   v2 fix: request each cart surface by its REAL section id (read from the
   element's data-id, exactly as Dawn does) instead of the hardcoded DOM id.
   The old version sent DOM ids ("main-cart-footer") as section names, so the
   Section Rendering API returned nothing usable and the totals block blanked
   until a manual refresh. Now the page/drawer/count refresh in place.

   Falls back to a normal form POST if the fetch throws.
   ========================================================================== */
if (!customElements.get('gc-cart-upsell')) {
  customElements.define(
    'gc-cart-upsell',
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('submit', (e) => {
          const form = e.target.closest('.gc-add-form');
          if (!form) return;
          e.preventDefault();
          this.add(form);
        });
      }

      get root() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      }

      onCartPage() {
        return !!document.getElementById('main-cart-items');
      }

      /* Each entry: which section id to request, which DOM node to update,
         and which inner selector to swap. section id comes from data-id so it
         matches whatever the cart.json keys are (cart-items / cart-footer). */
      sectionsSpec() {
        const spec = [];

        const items = document.getElementById('main-cart-items');
        if (items && items.dataset.id) {
          spec.push({ section: items.dataset.id, domId: 'main-cart-items', sel: '.js-contents' });
        }

        const footer = document.getElementById('main-cart-footer');
        if (footer && footer.dataset.id) {
          spec.push({ section: footer.dataset.id, domId: 'main-cart-footer', sel: '.js-contents' });
        }

        spec.push({ section: 'cart-icon-bubble', domId: 'cart-icon-bubble', sel: '.shopify-section' });

        if (document.getElementById('cart-live-region-text')) {
          spec.push({ section: 'cart-live-region-text', domId: 'cart-live-region-text', sel: '.shopify-section' });
        }

        if (document.getElementById('CartDrawer')) {
          spec.push({ section: 'cart-drawer', domId: 'CartDrawer', sel: '.drawer__inner' });
        }

        return spec;
      }

      add(form) {
        const idInput = form.querySelector('[name="id"]');
        const btn = form.querySelector('.gc-add');
        if (!idInput || !btn) return;

        const label = btn.dataset.label || btn.textContent.trim() || 'Add';
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Adding\u2026';

        const spec = this.sectionsSpec();
        const names = Array.from(new Set(spec.map((s) => s.section).filter(Boolean)));

        fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: idInput.value, quantity: 1 }],
            sections: names.join(','),
            sections_url: window.location.pathname
          })
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) {
              this.reset(btn, label);
              return;
            }
            this.applySections(spec, data.sections || {});
            this.afterAdd(btn, label);
            document.dispatchEvent(new CustomEvent('gc:cart:added', { detail: data }));
          })
          .catch(() => {
            form.submit();
          });
      }

      applySections(spec, sections) {
        spec.forEach((s) => {
          const html = sections[s.section];
          if (!html) return;
          const container = document.getElementById(s.domId);
          if (!container) return;
          const dest = container.querySelector(s.sel) || container;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const src = doc.querySelector(s.sel) || doc.querySelector('.shopify-section') || doc.body;
          if (src) dest.innerHTML = src.innerHTML;
        });

        const dr = document.querySelector('cart-drawer');
        if (dr) dr.classList.remove('is-empty');
      }

      afterAdd(btn, label) {
        if (document.body.contains(btn)) {
          btn.removeAttribute('aria-disabled');
          btn.textContent = 'Added \u2713';
          setTimeout(() => {
            if (document.body.contains(btn)) btn.textContent = label;
          }, 1600);
        }
        if (!this.onCartPage()) {
          const dr = document.querySelector('cart-drawer');
          if (dr && typeof dr.open === 'function') dr.open();
        }
      }

      reset(btn, label) {
        btn.removeAttribute('aria-disabled');
        btn.textContent = label;
      }
    }
  );
}